class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    document.body.classList.add('announcement-bar-visible');
    this.swiperElement = this.querySelector('[data-swiper-announcement-bar]');
    this.swiperOptions = {
      autoplay: {
        delay: 6000
      },
      slidesPerView: 2,
      direction: 'horizontal',
      breakpoints: {
        1024: {
          slidesPerView: 3
        }
      }
    }
    this.init();
  }
  init() {
    this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

    if(Shopify.designMode && this.swiperInstance) {

      window.addEventListener('shopify:section:load', () => {
        this.swiperInstance.update();
      });

      window.addEventListener('shopify:block:select', (event) => {
        this.swiperInstance.update();
        this.handleThemeEditorEvents(event);
      });
    }
  }

  /**
   * Handles the theme editor block change/edit event
   * @param {Object} event
   */
  handleThemeEditorEvents(event) {
    // Slide to slide based on the data attribute from the target and add 1 to get the slide index
    this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
  }


}

customElements.define('announcement-bar', AnnouncementBar);